module.exports = __webpack_public_path__ + "img/parser.e7522276.svg";